import styled from 'styled-components';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';

function RegisterStatusLimitTable({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="등기부현황은" isRegion={isRegion}>
      <SingleRowTable>
        <TableRow>
          <SingleRowTableHeadCell width="134px" style={{ fontWeight: 500 }}>
            채권액 합계
          </SingleRowTableHeadCell>
          <SingleRowTableBodyCell width="100%">
            해당내용없음
          </SingleRowTableBodyCell>
        </TableRow>
      </SingleRowTable>
    </LimitTableFilter>
  );
}

export default RegisterStatusLimitTable;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const SingleRowTableHeadCell = styled.div<{ width: string }>`
  width: 100%;
  text-align: center;
  border-top: 1px solid #222;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e1e2e4;
  padding: 6px 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;
`;
const YellowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(250, 177, 47, 0.1);
  border-radius: 8px;
  padding: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #a86c00;
`;
